import { Weight } from "lucide-react";
import React from "react";

function PoliticaPrivacidade() {
  return (
    <section className="canal-denuncias">
      <div className="container">
        <h1>Política de Privacidade - Amaratech</h1>

        <p>
          A Amaratech (“nós”, “nosso” ou “empresa”) respeita a sua privacidade e está comprometida em proteger seus dados pessoais.
          Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações quando você acessa nosso site.
        </p>

        <h2>1. Coleta de Dados</h2>
        <ul style={{ textAlign: "left", margin: "0 auto", maxWidth: "700px" }}>
          <li>Informações de contato fornecidas em formulários (nome, e-mail, telefone);</li>
          <li>Dados de navegação e cookies para análise de uso do site;</li>
          <li>Outros dados fornecidos voluntariamente pelo usuário.</li>
        </ul>

        <h2>2. Uso de Cookies</h2>
        <p>
          Nosso site utiliza cookies para melhorar sua experiência, personalizar conteúdo, analisar tráfego e entender como os visitantes interagem com nossas páginas.
          Você pode aceitar ou recusar o uso de cookies através do banner exibido no site.
        </p>

        <h2>3. Compartilhamento de Dados</h2>
        <p>
          Não compartilhamos suas informações pessoais com terceiros, exceto quando necessário para cumprimento de obrigações legais ou para a prestação de serviços contratados por você.
        </p>

        <h2>4. Armazenamento e Segurança</h2>
        <p>
          Seus dados são armazenados de forma segura, com acesso restrito aos nossos colaboradores autorizados.
          Tomamos medidas técnicas e organizacionais para proteger suas informações contra perda, uso indevido ou acesso não autorizado.
        </p>

        <h2>5. Seus Direitos</h2>
        <p>
          Você tem o direito de acessar, corrigir, excluir ou solicitar a portabilidade dos seus dados pessoais.
          Também pode revogar seu consentimento para uso de cookies e solicitar informações sobre como seus dados são tratados.
          Para exercer seus direitos, entre em contato conosco pelo e-mail{" "}
          <strong>contato@amaratech.com.br</strong>.
        </p>

        <h2>6. Alterações na Política de Privacidade</h2>
        <p>
          Podemos atualizar esta Política de Privacidade periodicamente. Sempre que houver alterações relevantes, notificaremos os usuários através do site ou e-mail.
        </p>

        <p>Esta política entra em vigor a partir da data de publicação no site.</p>
      </div>
    </section>
  );
}

export default PoliticaPrivacidade;
